import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Filtro } from 'src/app/models/filtro';
import { LogVendaCupom } from 'src/app/models/log-venda-cupom';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PaginatorService } from 'src/app/services/paginator.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-logs-venda-cupom-modal',
  templateUrl: './logs-venda-cupom-modal.component.html',
  styleUrls: ['./logs-venda-cupom-modal.component.scss']
})
export class LogsVendaCupomModalComponent implements OnInit {
  logs: LogVendaCupom[] = [];
  carregando = true;
  campoOrdenacao = 'dataHora';
  ordenarDesc = true;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'campo', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  idCupom: string = "";

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private pedidoService: PedidoService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private paginatorService: PaginatorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<LogsVendaCupomModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {
    this.idCupom = this.data.idCupom;
  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarLogVendaCupom();
  }

  buscarLogVendaCupom() {
    this.carregandoService.mostra('buscaLogVendaCupom');
    this.carregando = true;

    this.pedidoService.consultarLogVendaCupomComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.idCupom).subscribe((data: any) => {
        this.paginator.firstPage();
        this.logs = data.itens;
        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(data.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = data.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaLogVendaCupom');

      }, (erro) => {
        this.carregandoService.esconde('buscaLogVendaCupom');
        this.notificacaoService.erro(erro);
      });
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarLogVendaCupom();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.logs = this.logs.sort((a, b) => {
        const isAsc = !this.ordenarDesc;

        switch (this.campoOrdenacao) {
          case 'campo': return this.compare(a.campo, b.campo, isAsc);
          case 'dataHora': return this.compare(a.dataHora.toString(), b.dataHora.toString(), isAsc);
          default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  filtra() {
    this.buscarLogVendaCupom();
    this.paginator.firstPage();
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  retornaClasse(tipo) {
    if (tipo != null) {
      switch (tipo.toString()) {
        case "0":
          return "badge-danger";
        case "1":
          return "badge-primary";
        case "2":
          return "badge-success";
        case "3":
          return "badge-danger";

        default:
          return "badge-info";
          break;
      }
    }
    else {
      return "badge-info";
    }
  }

  retornaPerfilUsuario(tipo) {
    if (tipo != null) {
      switch (tipo.toString()) {
        case "0":
          return "Integrador";
        case "1":
          return "Vendedor";
        case "2":
          return "Administrador";
        case "3":
          return "Suporte";

        default:
          return "API";
          break;
      }
    } else {
      return "API";
    }
  }

  fechar() {
    this.dialogRef.close();
  }
}
